var scope_0 = require('/home/vsts/work/1/s/.cache/caches/gatsby-plugin-mdx/mdx-scopes-dir/6b5bdd90cf6c27ae63eda3a74a7bd67a.js').default;
var scope_1 = require('/home/vsts/work/1/s/.cache/caches/gatsby-plugin-mdx/mdx-scopes-dir/e92f8988d65cf25c087d226e6c0ef06f.js').default;export default
        Object.assign({}, scope_0,
scope_1 )
    